
import { Routes, Route, Navigate } from "react-router-dom";
import { useState, createContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CookiesProvider, useCookies } from 'react-cookie';
import { Notifications } from 'react-push-notification';

import Admin from "./views/admin/admin";
import SignIn from "./views/auth/SignIn";
import Interaction from "./views/Interaction";
import Navbar from "./components/navbar/Navbar";
import ManageUsers from "./views/adminManages/ManageUsers";
import ReactGA from "react-ga4";
import Notes from "./views/Notes/Notes";

import AddUser from "./views/admin/addUser";
import AddGroup from "./views/admin/addGroup";
import AddUserQR from "./views/admin/addUserQR";
import ManageGroups from "./views/adminManages/ManageGroups";
import RequestAccess from "./views/auth/RequestAccess";
import ManageRequests from "./views/adminManages/ManageRequests";
import AddIndividuals from "./views/admin/addIndividual";
import ManageIndividuals from "./views/adminManages/ManageIndividuals";

const trackingId = "G-QLJW08QMZ1";
ReactGA.initialize(trackingId);
const GAK = "1q2w3e4r";

const App = () => {
  const location = useLocation();
  const [cookies, setCookie] = useCookies(['GuruAccessKey']);

  const [enableAutoRefresh, setEnableAutoRefresh] = useState(false);
  const [showUsers, setShowUsers] = useState(false);
  const [showMedia, setShowMedia] = useState(false);
  const [readingMode, setReadingMode] = useState(true);
  const [isGroupBookmarked, setIsGroupBookmarked] = useState(false);
  const [fileId, setFileId] = useState("");
  const [quillDocs, setQuillDocs] = useState("");
  const [quillMessage, setQuillMessage] = useState("");
  const [fileName, setFileName] = useState("");
  const [filesList, setFilesList] = useState([]);
  const [currFolder, setCurrFolder] = useState(null);

  const [chats, setChats] = useState([]);
  const [groups, setGroups] = useState([]);
  const [groupName, setGroupName] = useState("");
  const [groupId, setGroupId] = useState("");

  // As soon as your profile is verified, you'll receive 
  const [generatedCode, setGeneratedQrCode] = useState("");
  const [name, setName] = useState("");

  const [mediaImageList, setMediaImageList] = useState([])
  const [mediaDocumentList, setmediaDocumentList] = useState([])
  const [clickedImg, setClickedImg] = useState(null)

  return (<Context.Provider value={{
    enAutoRefContext: [enableAutoRefresh, setEnableAutoRefresh],
    showUsersContext: [showUsers, setShowUsers],
    showMediaContext: [showMedia, setShowMedia],
    readingModeContext: [readingMode, setReadingMode],
    isGroupBookmarkedC: [isGroupBookmarked, setIsGroupBookmarked],
    fileIdContext: [fileId, setFileId],
    fileNameContext: [fileName, setFileName],
    quillDocsContext: [quillDocs, setQuillDocs],
    quillMessageContext: [quillMessage, setQuillMessage],
    filesListContext: [filesList, setFilesList],
    folderDetailsContext: [currFolder, setCurrFolder],

    mediaImageListC: [mediaImageList, setMediaImageList],
    mediaDocumentListC: [mediaDocumentList, setmediaDocumentList],
    clickedImageC: [clickedImg, setClickedImg],

    chatsContext: [chats, setChats],
    groupsContext: [groups, setGroups],
    groupNameContext: [groupName, setGroupName],
    groupIdContext: [groupId, setGroupId],

    generatedCodeC: [generatedCode, setGeneratedQrCode],
    nameC: [name, setName],
  }}>
    < CookiesProvider>
      <Notifications />
      <div style={{ height: "100dvh" }} className="h-screen w-screen min-h-0 flex flex-col font-ubuntu" >
        <Navbar />

        <div className={`${location.pathname.split("/")[1] === "signin" || location.pathname.split("/")[1] === "Request-to-Let-Me-In" ? "h-full" : "h-[calc(100%-50px)]"} overflow-auto w-full`} >
          <Routes>
            <Route path="/G/*" element={(localStorage.getItem('uid')) ? <Interaction /> : <Navigate to="/signin" />} />
            <Route path="/notes/*" element={(localStorage.getItem('uid')) ? <Notes /> : <Navigate to="/signin" />} />
            {/* <Route path="/G/*" element={<Interaction />} /> */}
            {/* <Route path="/admin" element={<Admin />} />
          <Route path="/admin/dashboard/*" element={<AdminDashboard />} />
          <Route path="/admin/manage-users/*" element={<ManageUsers />} /> */}

            <Route path="/GURU" element={(cookies.GuruAccessKey === GAK)
              ? <Navigate to="/GURU/manage-users/" /> : (localStorage.getItem('uid')) ? <Navigate to="/G" /> : <Navigate to="/signin" />} />

            <Route path="/GURU/manage-users/*" element={(cookies.GuruAccessKey === GAK)
              ? <ManageUsers /> : <Navigate to="/G" />} />

            <Route path="/GURU/manage-groups/*" element={(cookies.GuruAccessKey === GAK)
              ? <ManageGroups /> : <Navigate to="/G" />} />

            <Route path="/GURU/add-user/code" element={(cookies.GuruAccessKey === GAK)
              ? <AddUserQR /> : <Navigate to="/G" />} />

            <Route path="/GURU/add-group/code" element={(cookies.GuruAccessKey === GAK)
              ? <AddUserQR /> : <Navigate to="/G" />} />

            <Route path="/GURU/add-user" element={(cookies.GuruAccessKey === GAK)
              ? <AddUser /> : <Navigate to="/G" />} />

            <Route path="/GURU/add-group" element={(cookies.GuruAccessKey === GAK)
              ? <AddGroup /> : <Navigate to="/G" />} />

            <Route path="/GURU/add-individual" element={(cookies.GuruAccessKey === GAK)
              ? <AddIndividuals /> : <Navigate to="/G" />} />

            <Route path="/GURU/manage-individuals" element={(cookies.GuruAccessKey === GAK)
              ? <ManageIndividuals /> : <Navigate to="/G" />} />

            <Route path="/GURU/manage-requests" element={(cookies.GuruAccessKey === GAK)
              ? <ManageRequests /> : <Navigate to="/G" />} />

            <Route path="/signin" element={<SignIn />} />
            <Route path="/Request-to-Let-Me-In" element={<RequestAccess />} />
            <Route path="/GURU/*" element={(localStorage.getItem('uid')) ? <Navigate to="/G" /> : <Navigate to="/signin" />} />
            <Route path="/*" element={(localStorage.getItem('uid')) ? <Navigate to="/G" /> : <Navigate to="/signin" />} />
            {/* <Route path="/" element={<Navigate to="/G" replace />} /> */}
          </Routes>
        </div>
      </div>
    </CookiesProvider>
  </Context.Provider>
  );
};

export default App;
export const Context = createContext("Default");
